(() => {
  function initialize(root) {
    if (root.dataset.brandInitialized) return;
    root.dataset.brandInitialized = 'true';
    const current = new URL(window.location.href);
    const fallback = root.querySelector('[data-brand-search-fallback]');
    if (fallback) {
      const vendors = current.searchParams.getAll('filter.p.vendor');
      // Reconstruct only navigation when Shopify omits zero-result filters. Never
      // recover products from the URL or infer scope from the returned products.
      if (vendors.length !== 1 || !vendors[0].trim() || vendors[0].includes(',')) return;
      const vendor = vendors[0];
      const recoveryUrl = new URL(current.pathname, current.origin);
      recoveryUrl.searchParams.set('view', 'brand');
      recoveryUrl.searchParams.set('type', 'product');
      recoveryUrl.searchParams.set('q', '*');
      recoveryUrl.searchParams.set('filter.p.vendor', vendor);
      fallback.querySelector('[data-brand-fallback-title]').textContent = vendor;
      fallback.querySelector('[data-brand-fallback-vendor]').value = vendor;
      const recoveryLink = fallback.querySelector('[data-brand-fallback-link]');
      recoveryLink.href = recoveryUrl.href;
      // The scoped search works before a native vendor collection exists, too.
      // Omit its recovery link when this is already the all-products landing page.
      if (current.searchParams.get('q') === '*') recoveryLink.hidden = true;
      const hasOtherFilters = Array.from(current.searchParams.keys()).some(
        (name) => name.startsWith('filter.') && name !== 'filter.p.vendor',
      );
      if (current.searchParams.get('q') === '*' && !hasOtherFilters) {
        const isArabic = root.getAttribute('dir') === 'rtl';
        fallback.querySelector('.ribra-brand-products__empty h2').textContent = isArabic
          ? 'منتجات هذه الماركة قريبًا'
          : 'This brand is coming soon';
        fallback.querySelector('.ribra-brand-products__empty p').textContent = isArabic
          ? 'اكتشفي الماركات المتاحة حاليًا، وارجعي لاحقًا لمنتجات هذه الماركة.'
          : 'Explore the available brands and check back for products from this brand.';
      }
      const searchForm = fallback.querySelector('[data-brand-fallback-form]');
      current.searchParams.forEach((value, name) => {
        if (!name.startsWith('filter.') || name === 'filter.p.vendor') return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        searchForm.append(input);
      });
      root.querySelector('[data-brand-missing]').hidden = true;
      fallback.hidden = false;
      return;
    }
    const filters = root.querySelector('[data-brand-filters]');
    const details = root.querySelector('[data-brand-filter-details]');
    if (!filters) return;

    // The server remains authoritative; each interaction submits all native filters.
    root.querySelectorAll('[data-brand-auto-submit]').forEach((select) => {
      select.addEventListener('change', () => filters.requestSubmit());
    });

    const mobile = window.matchMedia('(max-width: 989px)');
    const setDisclosure = () => { if (details) details.open = !mobile.matches; };
    setDisclosure();
    mobile.addEventListener('change', setDisclosure);

    // Shopify creates these URLs. Retain the alternate view and locked vendor
    // explicitly as well, including when a future platform update omits a param.
    const isSearch = current.pathname.endsWith('/search');
    root.querySelectorAll('[data-brand-state-link], [data-brand-pagination] a').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('view', 'brand');
      if (isSearch) {
        url.searchParams.set('type', 'product');
        url.searchParams.set('filter.p.vendor', root.dataset.brand);
        url.searchParams.set('q', current.searchParams.get('q') || '*');
      } else {
        url.searchParams.set('q', new URL(root.dataset.vendorUrl, window.location.origin).searchParams.get('q'));
      }
      link.href = url.href;
    });
  }
  document.querySelectorAll('[data-ribra-brand-products]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ribra-brand-products]').forEach(initialize);
  });
})();
